<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="String($t('user_page.registered_remote_device'))")
    b-container(fluid)
      b-row.search-form
        b-col
        b-col.right-btns
          b-btn.delete-btn(size="sm" @click="selectDelete(allChecked)") {{$t('select_delete')}}
      b-card.table-card
        b-table(
          ref="agentTable",
          :fields="tableData.fields",
          :items="fetchList",
          :empty-text="$t('no-content')",
          tbody-class="lmm-table-body",
          show-empty
          responsive
        )
          //- header
          template(v-slot:head(check)="row")
            b-form-checkbox(v-model="allSelected" @input="selectAllRows")

          //- body
          template(v-slot:cell(check)="row")
            b-form-checkbox(v-model="row.item.isSelected" @change="handleCheck(row.item)")

          template(v-slot:cell(create_time)="row")
            span {{ row.item.create_time | moment('YY-MM-DD HH:mm') }}

          template(v-slot:cell(delete)="row")
            b-link.d-inline-flex(size="sm" @click="selectDelete([row.item])") #[span.svg-icon.trash delete]

      .modal-footer
        b-btn(size="sm" @click="visible = false" pill) {{$t('close')}}
    
    confirm-dialogs(:show.sync="showAgentDelete" :option="{ size: 'md', title: this.$t('delete_registered_manager') }")
      .warning
        icon.icon(name="exclamation-triangle" width="50" height="50")
        span ※ Warning ※
      .msg {{$t('confirm_delete_registered_device')}}
      .box
        .select
          span(v-for="item of deleteList" :key="item.pk") "{{ item.device_name }}"
        .msg(v-html="$t('device_deletion_logout_notice')")
        .msg(v-html="$t('user_page.re_registration_requirements')")
      .bottom-btns
        b-btn(size="sm" variant="danger" @click="del" pill) {{$t('delete')}}
        b-btn.btn-secondary(size="sm" @click="showAgentDelete = false" pill) {{$t('cancel')}}
</template>

<script>
import { UserEntityRegisterAPI } from "@/api"
import Dialogs from "@/components/mixins/dialog/index.vue"
import ConfirmDialogs from "@/components/mixins/dialog/confirm.vue"
import _ from "lodash"
import store from '@/api/store'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    userPk: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Dialogs,
    ConfirmDialogs,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    },
    visible(newVal) {
      if (!newVal) this.$emit("close", this.tableData.list.length)
    },
  },
  computed: {
    accountType() {
      return store.get('auth').account_type
    },
  },
  data() {
    return {
      visible: false,
      allSelected: false,
      allChecked: [],
      tableData: {
        fields: [
          {
            key: "check",
            label: "",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: false,
            thStyle: { width: "1%" },
          },
          { key: "device_name", label: `${this.$t('remote_device')} ${this.$t('name')}`, thStyle: { minWidth: "120px" } },
          { key: "memo", label: this.$t('memo'), thStyle: { minWidth: "120px" } },
          { key: "create_time", label: this.$t('registration_datetime'), thStyle: { minWidth: "120px" } },
          { key: "delete", label: this.$t('delete'), thStyle: { minWidth: "70px" } },
        ],
        list: [],
      },

      showAgentDelete: false,
      deleteList: [],
    }
  },
  methods: {
    fetchList() {
      let params = {
        input_type: "agent"
      }
      
      params.account_type = this.accountType;
      
      return UserEntityRegisterAPI.get(String(this.userPk), { params }).then(res => {
        const { objects } = res.data
        this.tableData.list = objects
        return this.tableData.list
      })
    },
    handleCheck(item) {
      if (this.allChecked.includes(item)) {
        const index = this.allChecked.findIndex(u => u.pk === item.pk)
        this.allChecked.splice(index, 1)
      }
      if (item.isSelected) {
        this.allChecked.push(item)
      }
    },
    selectAllRows() {
      _.each(this.tableData.list, v => {
        v.isSelected = this.allSelected
        this.handleCheck(v)
      })
    },
    selectDelete(items) {
      if (items.length === 0) {
        this.$bvToast.toast(this.$t('no-agent-selected'), {
          title: "Warning",
          variant: "warning",
          solid: true,
        })
        return
      }
      this.deleteList = _.cloneDeep(items)
      this.showAgentDelete = true
    },
    async del() {
      for (const item of this.deleteList) {
        const data = {
          input_type: "agent",
          device_id: item.device_id,
        }
        await UserEntityRegisterAPI.delete(String(this.userPk), { data })
      }
      this.$bvToast.toast(this.$t('toasts_message.manager_deleted'), {
        title: this.$t('success'),
        variant: "success",
        solid: true,
      })
      this.showAgentDelete = false
      this.$refs.agentTable.refresh()
    },
  },
}
</script>

<style lang="scss" scoped></style>
